<div class="grid auto-rows-auto gap-4 grid-cols-1 xl:grid-cols-2 m-4 w-full" *ngIf="isLoaded">
    <card-component headerTitle="Intervention" class="col-span-2" [collapsable]="true" [collapsed]="false">
        <app-form-fiche-intervention
            [idDossierIntervention]="idDossierIntervention"
            [currentFicheIntervention]="currentFicheIntervention"
            (onValueChanged)="this.unsavedChanges = $event"
            (onSaveNewFiche)="isNewFiche = false"
        ></app-form-fiche-intervention>
    </card-component>

    <card-component headerTitle="Travaux" class="col-span-2" *ngIf="!isNewFiche" [collapsable]="true" [collapsed]="false">
        <div class="flex shrink-0 items-center sm:ml-4" ngProjectAs="actions">
            <button class="ml-4" mat-flat-button [color]="'primary'" (click)="openTravauxModal()">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2 mr-1">Ajouter</span>
            </button>
        </div>
        <app-fiche-intervention-work-orders [workOrders]="workOrders" [workOrderTypes]="workOrderTypes" [pieces]="pieces" [ficheIntervention]="currentFicheIntervention" (editWorkOrder)="openTravauxModal($event)" (refreshWorkOrder)="fetchWorkOrders()"></app-fiche-intervention-work-orders>
    </card-component>
</div>
